import {IAgoraRTCClient, UID} from "agora-rtc-sdk-ng";
import Vue from 'vue';
import {AgoraVolumesManagerInterface} from "@share/web-conferences/interfaces/AgoraVolumesManagerInterface";
import {Volumes} from "@share/web-conferences/types/Volumes";

export class AgoraVolumesManager implements AgoraVolumesManagerInterface {
    list: Volumes = Vue.observable({});

    async start(client: IAgoraRTCClient): Promise<void> {
        client.enableAudioVolumeIndicator();
        client.removeAllListeners("volume-indicator");
        client.on("volume-indicator", this.volumeIndicatorHandler.bind(this));
    }

    volumeIndicatorHandler(data: { level: number; uid: UID }[]): void {
        data.forEach(audioLevelItem => {
            Vue.set(this.list, audioLevelItem.uid, audioLevelItem.level);
        });
    }

    clean(): void {
        this.list = {};
    }
}